<template>
    <stat-layout-card>
        <template #title>
            <h2 class="m-0">{{ data.title }}</h2>
        </template>
        <template #content>
            <ul v-if="items.length > 0" class="m-0">
                <li v-for="(item, itemIndex) in items" :key="itemIndex" ref="products">
                    <a
                        :href="
                            $router.resolve({
                                name: 'legacy.product.overview',
                                params: { id: item.value.id },
                            }).href
                        "
                        class="px-5 py-2 fs-3 hover-primary-05-bkg cpointer flex-level gray-100"
                    >
                        <CompassTooltip
                            class="stat-list-card__tooltip"
                            :content="item.value.name"
                            :disabled="item.disableTooltip"
                            :arrow="false"
                            :contentClass="'stat-list-card__tooltip-item'"
                        >
                            <div class="ellipsis mr-3">
                                {{ itemIndex + 1 }} - {{ item.value.name }}
                            </div>
                        </CompassTooltip>
                        <div class="flex-right gray-60 nowrap">
                            {{ $filters.numberFormat(item.value.total) }} {{ item.unit }}
                        </div>
                    </a>
                </li>
            </ul>
            <div v-else class="acenter">
                <span>{{ $l10n.__('Pas de produits / services vendus pour ce client.') }}</span>
            </div>
        </template>
    </stat-layout-card>
</template>

<script>
import StatLayoutCard from './StatLayoutCard.vue';
export default {
    components: {
        StatLayoutCard,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            items: this.data.slots.items?.slots ? this.data.slots.items?.slots : [],
        };
    },
    mounted() {
        if (this.$refs.products) {
            this.$refs.products.forEach((product, index) => {
                const tooltip = product.querySelector('.ellipsis');
                this.items[index].disableTooltip = tooltip.scrollWidth <= tooltip.offsetWidth;
            });
            this.$forceUpdate();
        }
    },
};
</script>
<style lang="scss">
.stat-list-card__tooltip {
    min-width: 0;

    &-item {
        max-width: 320px;
    }

    .compass-tooltip__element {
        max-width: 100%;
    }
}
</style>
